export default __webpack_public_path__ + "static/media/GreatFood.27e0dc5b.mp4";